import React from 'react';
import LegalDocument from '../components/page/LegalDocument';
import {
  privacyPolicyMeta,
  privacyPolicyArticles,
  privacyPolicyContact,
  privacyPolicyEstablishedDate,
  privacyPolicyRevisedDate,
} from '../data/privacyPolicy';
import usePageMeta from '../lib/usePageMeta';
import { PAGE_META } from '../data/pageMeta';

const PrivacyPolicy = () => {
  usePageMeta(PAGE_META.privacyPolicy);
  return (
    <LegalDocument
      label={privacyPolicyMeta.label}
      title={privacyPolicyMeta.title}
      lead={privacyPolicyMeta.lead}
      articles={privacyPolicyArticles}
      contact={privacyPolicyContact}
      establishedDate={privacyPolicyEstablishedDate}
      revisedDate={privacyPolicyRevisedDate}
      accent="blue"
    />
  );
};

export default PrivacyPolicy;
